/**
 * "Placeras på allmän plats" + the acknowledgement it requires. Used when a
 * QR code is created and when it is regenerated: the choice is fixed per code.
 */
import React from 'react';
import { Form } from 'react-bootstrap';

export interface PublicPlacementValue {
    publicPlacement: boolean;
    acknowledged: boolean;
}

export const INTERNAL_PLACEMENT: PublicPlacementValue = { publicPlacement: false, acknowledged: false };

/** A public code can be created only once the responsibility is acknowledged */
export const isPlacementComplete = (value: PublicPlacementValue): boolean =>
    !value.publicPlacement || value.acknowledged;

interface PublicPlacementFieldsProps {
    idPrefix: string;
    value: PublicPlacementValue;
    onChange: (value: PublicPlacementValue) => void;
    /** Whether the instance has a privacy policy */
    hasPolicy: boolean;
    disabled?: boolean;
}

const PublicPlacementFields: React.FC<PublicPlacementFieldsProps> = ({
    idPrefix,
    value,
    onChange,
    hasPolicy,
    disabled,
}) => (
    <div className="public-placement-fields">
        <Form.Check
            type="checkbox"
            id={`${idPrefix}-public`}
            label="Placeras på allmän plats"
            checked={value.publicPlacement}
            onChange={e => onChange({ publicPlacement: e.target.checked, acknowledged: false })}
            disabled={disabled}
        />
        <Form.Text className="text-muted d-block public-placement-fields__hint">
            Koden kan skannas av personer från allmänheten.
        </Form.Text>

        {value.publicPlacement && (
            <div className="public-placement-fields__public">
                <Form.Check
                    type="checkbox"
                    id={`${idPrefix}-ack`}
                    label={
                        <>
                            <strong>Vi är personuppgiftsansvariga.</strong> Vi förstår att vi som sätter upp koden
                            ansvarar för att informera de som skannar den om hur deras personuppgifter hanteras,
                            och att vi själva tillhandahåller integritetspolicyn.
                        </>
                    }
                    checked={value.acknowledged}
                    onChange={e => onChange({ ...value, acknowledged: e.target.checked })}
                    disabled={disabled}
                />
                <div className="small mt-2">
                    {hasPolicy ? (
                        <span className="text-success">Integritetspolicy: angiven. Den visas för den som skannar koden.</span>
                    ) : (
                        <span className="text-muted">
                            Integritetspolicy: ej angiven. Den som skannar ser bara en uppmaning att inte skriva
                            personuppgifter. Lägg till er policy under "Integritetspolicy för publika koder".
                        </span>
                    )}
                </div>
            </div>
        )}
    </div>
);

export default PublicPlacementFields;
